import React, { useEffect, useState } from 'react';
import { Chip } from '@mui/material';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';
import { useSelector } from 'react-redux';

import { ACTIONS_TYPES } from 'redux/helper';
import { locations } from 'utils';
import { ROUTE } from 'constant';
import CreateForm from './create';

export default () => {
  const [ipsList, setIpsList] = useState([]);
  const [deleteId, setDeleteId] = useState('');

  const { [ACTIONS_TYPES.IP.GET_ALL]: ips = [] } = useSelector((e) => e);

  useEffect(() => {
    actions.ip.getAll();
    actions.common.setLayoutTitle({
      layout: { title: 'IPs', menu: ROUTE.DASHBOARD.IPS.key },
    });
  }, []);

  useEffect(() => {
    setIpsList([...ips]);
  }, [ips]);

  const selectToDelete = (id) => {
    setDeleteId(id);
  };

  const onDelete = (confirm) => {
    if (confirm) {
      actions.ip.delete({ id: deleteId });
    }
    setDeleteId('');
  };

  return (
    <div style={{ margin: '15px 10px' }} className="screen-common">
      <Shared.widgets.Cards
        title="IP Blocks"
        type="common"
        isFilter={false}
        addAction={ACTIONS_TYPES.IP.CREATE}
        addRender={<CreateForm />}
      >
        {ipsList.map((_ips) => {
          const { properties, id } = _ips;
          const { name, ips: ipsInner = [], location } = properties;
          const { image: locImage = '', name: locName = '' } = locations[location] || {};

          return (
            <Shared.widgets.CardBasic
              title={name}
              // icon="network-wired"
              // iconText="IP Block"
              details={(
                <>
                  <span>
                    <img src={locImage} alt="country logo" style={{ width: 16, height: 16, verticalAlign: 'middle' }} />
                    <span style={{ position: 'relative', top: 1, left: 5 }}>{locName}</span>
                  </span>
                  <div
                    style={{
                      marginTop: 5,
                      display: 'flex',
                      flexFlow: 'wrap',
                      maxHeight: 55,
                      letterSpacing: 0.5,
                      overflowY: ipsList.length > 2 ? 'scroll' : 'hidden',
                    }}
                  >
                    {ipsInner.map((e) => (
                      <span
                        style={{ marginRight: 8, marginBottom: 4 }}
                        key={e}
                      >
                        <Chip
                          icon={<Shared.widgets.Icon name="circle" style={{ color: 'var(--color-success)' }} />}
                          label={e}
                          style={{ height: 26, background: 'var(--color-ground)' }}
                        />
                      </span>
                    ))}
                  </div>
                </>
              )}
              actionButtons={{
                delete: () => selectToDelete(id),
              }}
              key={id}
            />
          );
        })}
      </Shared.widgets.Cards>
      <Shared.dialog.Confirm show={!!deleteId} onClose={onDelete} />
    </div>
  );
};
